// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

//** Location Cascade Api
export const getDashboardCurrentAttendance = createAsyncThunk('dashboardAttendanceSlice/getDashboardCurrentAttendance', async (data) => {
    try {
        const query = queryString.stringify(data);

        let response = await axios.get('/Dashboard/current-attendance?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getDashboardAbsentAttendance = createAsyncThunk('dashboardAttendanceSlice/getDashboardAbsentAttendance', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/Dashboard/absent-attendance?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getAbsentAttendanceDetails = createAsyncThunk('dashboardAttendanceSlice/getAbsentAttendanceDetails', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/Dashboard/absent-attendance-details?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getCurrentAttendanceDetails = createAsyncThunk('dashboardAttendanceSlice/getCurrentAttendanceDetails', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/Dashboard/punch-by-employee?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const dashboardAttendanceSlice = createSlice({
    name: 'dashboardAttendanceSlice',
    initialState: {
        data: [],
        absentData: [],
        absentDetails: [],
        currentAttendanceDetails: []
    },

    extraReducers: (builder) => {
        builder.addCase(getDashboardCurrentAttendance.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getDashboardAbsentAttendance.fulfilled, (state, action) => {
            state.absentData = action?.payload;
            return;
        });
        builder.addCase(getAbsentAttendanceDetails.fulfilled, (state, action) => {
            state.absentDetails = action?.payload;
            return;
        });
        builder.addCase(getCurrentAttendanceDetails.fulfilled, (state, action) => {
            state.currentAttendanceDetails = action?.payload;
            return;
        });
    }
});

export default dashboardAttendanceSlice.reducer;
